import { createAction, props } from "@ngrx/store";
import { CurrentSessionData } from "src/model/class/general classes/current-session-data";
import { AuthStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Action set current, "BIGStudio3"-related User
 */
export const currentUserSetAction = createAction(
  AuthStoreAction.CURRENT_USER_SET,
  props<{ currentUser: CurrentSessionData }>()
);

/**
 * Action update name and surname of user
 */
export const currentUserUpdateData = createAction(
  AuthStoreAction.CURRENT_USER_UPDATE_DATA,
  props<{ name: string; surname: string }>()
);

/**
 * Action update consent user
 */
export const currentUserUpdateConsents = createAction(
  AuthStoreAction.CURRENT_USER_UPDATE_DATA,
  props<{ commercialComunication: boolean; personalizingService: boolean }>()
);

/**
 * Action update name and surname of user
 */
export const currentUserUpdatePassword = createAction(
  AuthStoreAction.CURRENT_USER_UPDATE_PASSWORD,
  props<{ password: string }>()
);

/**
 * Action unset current User, be it "BIGStudio3"-related or "DigitalPlace"-related
 */
export const currentUserUnsetAction = createAction(
  AuthStoreAction.CURRENT_USER_UNSET
);
